module.exports = __webpack_public_path__ + "img/list-data.4ef1936d.png";